module.exports = ".user-menu, .user-menu span {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/homepage/homepage.component.scss
// module id = ./src/app/homepage/homepage.component.scss
// module chunks = main